export const trabajos = [
    {   
        'Control': 'MP',
        'id': 'Macpuarsa',
        'tipo': 'Tipo: Electromecanico',
        'targeta': 'Tarjeta: Microbasic',
        'Traccion': 'Traccion: VF',
        'Empresa': 'Empresa: Duplex'
    },
    {
        'Control': 'Controles S.A',
        'id': 'ControlesSA',
        'tipo': 'Tipo: Electromecanico',
        'targeta': 'Tarjeta: CEA51',
        'Traccion': 'Traccion: VF',
        'Empresa': 'Empresa: ESAT'
    },
    {
        'Control': 'SYEC',
        'id': 'SYEC-Monarch',
        'tipo': 'Tipo: Electromecanico',
        'targeta': 'Targeta: Monarch Nice 3000',
        'Traccion': 'INV',
        'Empresa': 'Empresa: Duplex'
    },
    {
        'Control': 'Schindler 3300',
        'id': 'Schindler-3300',
        'tipo': 'Tipo: Electromecanico',
        'targeta': 'Targeta: SDIC',
        'Traccion': 'Tracion: VF',
        'Empresa': 'Empresa: Schindler'
    },
    {
        'Control': 'Miconic LX',
        'id': 'LX',
        'tipo': 'Tipo: Electromecanico',
        'targeta': 'Targeta: PG268',
        'Traccion': 'Traccion: VF',
        'Empresa': 'Empresa: Schindler'
    },
    {
        'Control': 'Atlas Excel',
        'id': 'Atlas-Excel',
        'tipo': 'Tipo: Electromecanico',
        'targeta': 'Targeta: jvo151',
        'Traccion': 'Traccion: VF',
        'Empresa': 'Empresa: Schindler'
    },
    {
        'Control': 'MX GC',
        'id': 'MX-GC',
        'tipo': 'Tipo: Electromecanico',
        'targeta': 'Tarjeta: Asixa',
        'Traccion': 'Traccion: VF',
        'Empresa': 'Empresa: Duplex'
    },
    
];